import tokens from "../../assets/data/tokens.json";
export function initMotion({ gsap, ScrollTrigger, SplitText, motion, scope }) {
  const document=scope.document;
  const window=scope.ownerDocument.defaultView;
  const matchMedia=window.matchMedia.bind(window);
  let context,
    splits = [],
    curtain,
    firstRun = true,
    fontsReady = false;
  const clock = (el, value) => {
    const total = Math.round(value);
    const parts = [
      Math.floor(total / 3600),
      String(Math.floor((total % 3600) / 60)).padStart(2, "0"),
      String(total % 60).padStart(2, "0"),
    ];
    el.querySelectorAll("[data-time-part]").forEach(
      (part, i) => (part.textContent = parts[i]),
    );
  };
  const resetCounters = () => {
    document
      .querySelectorAll("[data-counter]")
      .forEach((el) => (el.textContent = el.dataset.counter));
    document.querySelectorAll("[data-time]").forEach((el) => {
      const p = el.dataset.time.split(":").map(Number);
      clock(el, p[0] * 3600 + p[1] * 60 + p[2]);
      el.classList.add("is-counted");
    });
  };
  const headings = () => {
    if (!fontsReady || !motion.enabled) return;
    context.add(() =>
      document.querySelectorAll("[data-split]").forEach((el) => {
        const split = SplitText.create(el, {
          type: "lines,words",
          mask: "lines",
          autoSplit: true,
          onSplit(self) {
            return gsap.from(self.words, {
              yPercent: 110,
              rotation: 1.5,
              duration: 0.8,
              stagger: 0.025,
              ease: "power3.out",
              scrollTrigger: { trigger: el, start: "top 96%", once: true },
            });
          },
        });
        splits.push(split);
      }),
    );
  };
  const start = () => {
    if(!scope.alive) return;
    context?.revert();
    splits.forEach((s) => s.revert());
    splits = [];
    curtain?.remove();
    resetCounters();
    if (!motion.enabled) {
      firstRun = false;
      return;
    }
    context = gsap.context(() => {
      const hero = document.querySelector(".aw-hero__media");
      if (hero && firstRun && window.scrollY < 100 && !scope.editor && scope.ownerDocument.querySelector(".aw-hero__media") === hero) {
        curtain = document.createElement("div");
        curtain.className = "aw-intro-curtain";
        curtain.setAttribute("aria-hidden", "true");
        document.body.append(curtain);
        gsap.to(curtain, {
          scaleX: 0,
          skewX: -14,
          transformOrigin: "100% 50%",
          duration: 1.05,
          ease: "power4.inOut",
          onComplete: () => curtain.remove(),
        });
        const intro = gsap.timeline({ defaults: { ease: "power3.out" } });
        intro
          .fromTo(
            hero,
            { clipPath: "polygon(0 0,0 0,0 100%,0 100%)" },
            { clipPath: "polygon(0 0,100% 0,100% 100%,0 100%)", duration: 1.15, clearProps: "clipPath" },
            0.15,
          )
          .from(
            hero.querySelector(".aw-hero__photo"),
            { scale: 1.12, duration: 1.4 },
            0.15,
          );
        const mark = hero.querySelector(".aw-hero__mark");
        if (mark) intro.from(mark, { x: -180, duration: 1.25 }, 0.25);
      }
      document.querySelectorAll(".aw-contact__media").forEach((media) => {
        const wipe = media.querySelector(".aw-contact__wipe");
        gsap.set(wipe, { visibility: "visible" });
        gsap
          .timeline({
            scrollTrigger: { trigger: media, start: "top 96%", once: true },
          })
          .fromTo(
            wipe,
            { scaleX: 1, skewX: 0 },
            {
              scaleX: 0,
              skewX: -14,
              transformOrigin: "100% 50%",
              duration: 1.05,
              ease: "power4.inOut",
              onComplete: () => gsap.set(wipe, { visibility: "hidden" }),
            },
            0,
          )
          .from(
            media.querySelector("img"),
            { scale: 1.08, duration: 1.15, ease: "power3.out" },
            0,
          );
      });
      document.querySelectorAll(".aw-gallery").forEach((gallery) => {
        const links = gallery.querySelectorAll(".aw-gallery__link");
        links.forEach((link, i) =>
          gsap.from(link, {
            y: 64,
            rotation: [-3, 3, -2][i % 3],
            duration: parseFloat(tokens["motion-gallery"]),
            ease: "power3.out",
            scrollTrigger: { trigger: link, start: "top 100%", once: true },
          }),
        );
        const shapes = [
          ...gallery.querySelectorAll(".aw-gallery__shape"),
        ].filter((n) => n.offsetWidth > 0);
        if (shapes.length)
          gsap.from(shapes, {
            x: -180,
            duration: parseFloat(tokens["motion-shape"]),
            ease: "power3.out",
            scrollTrigger: { trigger: gallery, start: "top 100%", once: true },
          });
      });
      document.querySelectorAll(".aw-training__grid").forEach((grid) => {
        [...grid.children].forEach((item, i) =>
          gsap.from(item, {
            y: 22,
            autoAlpha: 0,
            delay: (i % (window.innerWidth < 768 ? 1 : 3)) * 0.12,
            duration: 0.65,
            ease: "power2.out",
            scrollTrigger: { trigger: item, start: "top 95%", once: true },
          }),
        );
      });
      document
        .querySelectorAll(".aw-cta--coach .aw-cta__media")
        .forEach((media) =>
          gsap.from(media.querySelector("img"), {
            xPercent: -55,
            duration: 1.25,
            ease: "power3.out",
            scrollTrigger: { trigger: media, start: "top 95%", once: true },
          }),
        );
      document
        .querySelectorAll(".aw-statistics__numbers")
        .forEach((numbers) => {
          const block = numbers.closest(".aw-block");
          gsap.from(numbers.children, {
            y: 80,
            rotation: 2,
            autoAlpha: 0,
            stagger: 0.15,
            duration: 0.8,
            ease: "power3.out",
            scrollTrigger: { trigger: block, start: "top 70%", once: true },
          });
          numbers.querySelectorAll("[data-counter]").forEach((el) => {
            const o = { value: 0 };
            gsap.to(o, {
              value: Number(el.dataset.counter),
              duration: 1.6,
              ease: "power2.out",
              scrollTrigger: { trigger: block, start: "top 70%", once: true },
              onUpdate: () => (el.textContent = Math.round(o.value)),
              onComplete: () => (el.textContent = el.dataset.counter),
            });
          });
          const time = numbers.querySelector("[data-time]");
          if (time) {
            time.classList.remove("is-counted");
            const p = time.dataset.time.split(":").map(Number),
              total = p[0] * 3600 + p[1] * 60 + p[2],
              o = { value: 0 };
            gsap.to(o, {
              value: total,
              duration: 1.6,
              ease: "power2.out",
              scrollTrigger: { trigger: block, start: "top 70%", once: true },
              onUpdate: () => clock(time, o.value),
              onComplete: () => {
                clock(time, total);
                time.classList.add("is-counted");
              },
            });
          }
          const shape = numbers
            .closest(".aw-block")
            .querySelector(".aw-statistics__shape");
          if (shape)
            gsap.from(shape, {
              x: 420,
              scaleX: 0.7,
              duration: parseFloat(tokens["motion-shape"]),
              ease: "power2.out",
              scrollTrigger: { trigger: block, start: "top 75%", once: true },
            });
        });
      document.querySelectorAll(".aw-film-band__photo").forEach((band) => {
        if (matchMedia("(min-width:768px)").matches)
          gsap.fromTo(
            band,
            { yPercent: -8, scale: 1.15 },
            {
              yPercent: 8,
              scale: 1.05,
              ease: "none",
              scrollTrigger: {
                trigger: band.parentNode,
                start: "top bottom",
                end: "bottom top",
                scrub: 0.6,
              },
            },
          );
      });
    });
    firstRun = false;
    headings();
    ScrollTrigger.refresh();
  };
  // Image timelines start at initialization. Font readiness only affects SplitText.
  start();
  document.fonts.ready.then(() => {
    if (!scope.alive) return;
    fontsReady = true;
    headings();
    ScrollTrigger.refresh();
  });
  scope.on(document, "focusin", (e) => {
    if(!scope.root.contains(e.target))return;
    const block = e.target.closest(".aw-block");
    if (block)
      ScrollTrigger.getAll()
        .filter((t) => block.contains(t.trigger))
        .forEach((t) => t.animation?.progress(1));
  });
  scope.onDispose(()=>{context?.revert();splits.forEach(s=>s.revert());curtain?.remove();resetCounters();});
  return { refresh: start };
}
